// extracted by mini-css-extract-plugin
export var addButton = "_if-0";
export var border = "_if-8";
export var check = "_if-h";
export var danger = "_if-6";
export var dropdownContainer = "_if-1";
export var editModalBody = "_if-j";
export var footerContainer = "_if-i";
export var fullWidth = "_if-a";
export var hide = "_if-9";
export var icon = "_if-3";
export var input = "_if-7";
export var inputFlex = "_if-b";
export var inputWrapper = "_if-c";
export var manualFocus = "_if-5";
export var optionButton = "_if-4";
export var pillWrapper = "_if-e";
export var pointer = "_if-2";
export var showOverflow = "_if-f";
export var tagsFlex = "_if-d";
export var xButton = "_if-g";